import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-14b4be32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_2 = { class: "col-form-label fw-bold mb-2" }
const _hoisted_3 = { class: "d-flex justify-content-end mb-3" }
const _hoisted_4 = { class: "bg-white rounded-4 shadow p-4 mb-5" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  colspan: "11",
  class: "text-center fw-bold"
}

import Breadcrumb from '@/components/breadcrumb/index.vue'
import { useRoute, useRouter } from 'vue-router'
import {
  allowedSortFields,
  ARTICLE_CELL_ACTION,
  ARTICLE_MODAL_ID,
  ARTICLE_PUBLISH_STATUS_FIELD_NAME,
  ARTICLE_SEARCH_PUBLISH_STATUS_PRIVATE_VALUE,
  ARTICLE_SEARCH_PUBLISH_STATUS_PUBLIC_VALUE,
  breadcrumb,
  COMMENT_USER_ALUMNI_MODAL_ID,
  COMMENT_USER_MODAL_ID,
  DELETE_COMMENT_MODAL_ID,
  DELETE_COMMENT_SUCCESS_MODAL_ID,
  DELETE_COMPLETE_MODAL_ID,
  DELETE_CONFIRM_MODAL_ID,
  CONFIRM_UPDATE_STATUS_COMMENT_MODAL_ID,
  displayColumns,
  LIKE_MODAL_ID,
  tablePageSizeOptions,
  URL_ARTICLE_CREATE_PATH,
  URL_ARTICLE_LIST_PATH,
  URL_QUERY,
  RESULT_UPDATE_STATUS_COMMENT_MODAL_ID,
} from '@/views/community-admin/community-site/constants'
import { translate } from '@/languages/i18n'
import CommunitySiteArticleSearch from '@/views/community-admin/community-site/components/CommunitySiteArticleSearch.vue'
import Button from '@/components/button/index.vue'
import TotalRecords from '@/components/total-records/index.vue'
import Table from '@/components/table/index.vue'
import { computed, onMounted, ref, toRaw, reactive } from 'vue'
import _, { omit, pick } from 'lodash'
import TableRowData from '@/views/community-admin/community-site/components/TableRowData.vue'
import TablePagination from '@/views/community-admin/community-site/components/TablePagination.vue'
import DeleteConfirmModal from '@/views/community-admin/community-site/components/modals/DeleteConfirmModal.vue'
import { Modal } from 'bootstrap'
import LikeModal from '@/views/community-admin/post-management/components/LikeModal.vue'
import DeleteCompleteModal from '@/views/community-admin/community-site/components/modals/CompleteModal.vue'
import { ACCOUNT_STORE, COMMUNITY_SITE_ADMIN_STORE, POST_STORE } from '@/store/constants'
import { useStore } from 'vuex'
import ArticleModal from '@/views/community-admin/community-site/components/modals/ArticleModal.vue'
import { ComputedRef, watch } from 'vue-demi'
import { PostType } from '@/store/modules/post'
import userPostService from '@/services/user-post.services'
import Loading from '@/components/loading/index.vue'
import postServices from '@/services/post.services'
import DeleteCommentModal from '@/views/shared/communities/components/DeleteCommentModal.vue'
import { changeModalElevation } from '@/utils'
import DeleteCommentCompleteModal from '@/views/shared/communities/components/DeleteCommentSuccessModal.vue'
import { CommentType } from '@/store/modules-community-admin/community-site'
import PortfolioUser from '@/views/community-admin/user-management/employee-user/detail/components/PortfolioUser.vue'
import PortfolioAlumni from '@/views/community-admin/user-management/alumni-user/detail/components/PortfolioAlumni.vue'
import ModalConfirmStatusComment from '@/views/community-admin/post-management/components/ModalConfirmStatusComment.vue'
import ModalUpdateStatusCommentResult from '@/views/community-admin/post-management/components/ModalUpdateStatusCommentResult.vue'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute()
const router = useRouter()
const store = useStore()

// Prevent multi-tap on button
const isLoading = ref()
const deleteArticleConfirmDialog = ref()
const sortField = ref<string>(URL_QUERY.CREATE_AT)
const selectedArticle = ref()
const selectedComment = ref()
// Modal reference
const deleteCommentConfirmModal = ref()
const deleteCommentSuccessModal = ref()
const articleDetailModalController = ref()
const commentUserInfoModal = ref()
const commentAlumniInfoModal = ref()
const deleteResult = ref(true)
const modalConfirmStatusComment = ref()
const modalUpdateStatusCommentResult = ref()
const resultUpdateStatusComment = reactive({
  success: true,
  commentPublished: true,
})
const componentModalConfirmComment = ref()

const checkSearchData = computed((): boolean => Object.keys(pick(route.query, URL_QUERY.TITLE, URL_QUERY.CONTENT, URL_QUERY.PUBLIC_ARTICLE, URL_QUERY.PRIVATE_ARTICLE)).length > 0)
const checkNoData = computed((): boolean => data.value.length === 0)
const data: ComputedRef<Array<PostType>> = computed((): Array<PostType> => store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.ARTICLE_LIST])
const totalPages: ComputedRef<number> = computed((): number => store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.TOTAL_PAGES])
const totalRecords: ComputedRef<number> = computed((): number => store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.TOTAL_RECORDS])

// Make sure that only defined value of page size can be queried from url
// Otherwise -> query with default page size
const getPageSize = computed((): number => calculatePageSize())

onMounted(() => {
  const storedQueries = toRaw(store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.GET_CURRENT_QUERY])
  if (route.query && route.query[URL_QUERY.REFRESH]) {
    router.replace({ path: route.path, query: _.omit(route.query, URL_QUERY.REFRESH) })
  }
  // When user is from edit/create article flow, come back to list page
  // their last search query must stayed remain
  else if (!_.isEmpty(storedQueries)) {
    // Check whether user is navigated from sidebar,
    // if true -> remove the query from url
    if (route.query && route.query[URL_QUERY.FROM_SIDE_NAV]) {
      router.replace({ path: route.path, query: _.omit(route.query, URL_QUERY.FROM_SIDE_NAV) })
    }
    // in cased of navigation from other page,
    // remove current queries, refresh it for below logic
    else if (route.query?.post_id) {
      router.replace({ path: route.path, query: { ...route.query, [URL_QUERY.REFRESH]: 1 } })
    }
    // Replace current url with last stored query then remove those query from store
    else {
      _.isEqual(route.query, storedQueries) ? fetchCommunitySiteData() : router.replace({ path: route.path, query: { ...route.query, ...storedQueries } })
      store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.STORE_CURRENT_QUERY, null)
    }
  } else {
    // Check whether user is navigated from sidebar,
    // if true -> remove the query from url
    if (route.query && route.query[URL_QUERY.FROM_SIDE_NAV]) {
      router.replace({ path: route.path, query: _.omit(route.query, URL_QUERY.FROM_SIDE_NAV) })
    }
    fetchCommunitySiteData()
    if (store.getters[COMMUNITY_SITE_ADMIN_STORE.GETTERS.RESET_FLAG]) {
      store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.UPDATE_RESET_FLAG, { flag: false })
      router.replace({ path: router.currentRoute.value.path })
    }
    // Show modal detail if exists query post_id
    if (route.query?.post_id) {
      const article = {
        id: route.query?.post_id,
      }
      handleArticleAction(article, ARTICLE_CELL_ACTION.COMMENT)
    }
    configModalVisibleState()
  }
})

watch(
  () => route,
  (op, np) => {
    if (np.path === URL_ARTICLE_LIST_PATH(route.params.id)) {
      if (route.query && route.query[URL_QUERY.REFRESH]) {
        router.replace({ path: route.path, query: _.omit(route.query, URL_QUERY.REFRESH) })
      } else {
        // Check whether user is navigated from sidebar,
        // if true -> remove the query from url
        if (route.query && route.query[URL_QUERY.FROM_SIDE_NAV]) {
          router.replace({ path: route.path, query: _.omit(route.query, URL_QUERY.FROM_SIDE_NAV) })
        }
        fetchCommunitySiteData()
      }
    }
  },
  {
    deep: true,
  }
)

const storeCurrentQuery = async () => {
  await store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.STORE_CURRENT_QUERY, route.query)
}

const handleWriteArticleButtonClick = () => {
  const communityId = router.currentRoute.value.params.id?.toString() ?? ''
  storeCurrentQuery()
  router.push(URL_ARTICLE_CREATE_PATH(communityId))
}

const showModalDetail = ref(false)
const handleArticleAction = async (article: any, action: ARTICLE_CELL_ACTION) => {
  selectedArticle.value = article
  if (action === ARTICLE_CELL_ACTION.DELETE) {
    showArticleDeleteConfirmationModal()
  }
  if (action === ARTICLE_CELL_ACTION.LIKE) {
    getLikeUserList()
    showArticleLikeListModal()
  }
  if (action === ARTICLE_CELL_ACTION.COMMENT) {
    if (showModalDetail.value) return
    showModalDetail.value = true
    await getArticleDetail()
    await getListUser()
    await getUserMention()
    showArticleContentModal()
    showModalDetail.value = false
  }
}

const showArticleDeleteConfirmationModal = () => {
  deleteArticleConfirmDialog.value = new Modal(document.getElementById(DELETE_CONFIRM_MODAL_ID) as HTMLElement)
  deleteArticleConfirmDialog.value.show()
}

const deleteArticle = async (articleId: number) => {
  if (articleId === selectedArticle.value.id) {
    isLoading.value = true
    const data = await userPostService.deleteUserPosts(selectedArticle.value?.id ?? 0)
    if (data && data.data?.success) {
      deleteResult.value = { success: true }
      deleteArticleSuccess()
    } else {
      deleteResult.value = { success: false }
      // In case of confirm modal is currently showing -> hide it
      deleteArticleConfirmDialog.value?.hide()
      isLoading.value = false

      // Show complete dialog
      const deleteCompleteModal = new Modal(document.getElementById(DELETE_COMPLETE_MODAL_ID) as HTMLElement)
      deleteCompleteModal.show()
    }
  }
}

/**
 * Callback after article has been deleted completely
 */
const deleteArticleSuccess = () => {
  // In case of confirm modal is currently showing -> hide it
  deleteArticleConfirmDialog.value?.hide()
  isLoading.value = false

  // Re-fetch latest table data
  fetchCommunitySiteData()

  // Show complete dialog
  const deleteCompleteModal = new Modal(document.getElementById(DELETE_COMPLETE_MODAL_ID) as HTMLElement)
  deleteCompleteModal.show()
}

const getLikeUserList = () => {
  store.dispatch(POST_STORE.ACTIONS.GET_LIKES, { id: selectedArticle.value?.id ?? 0, params: { create_by_admin: true } })
}

const showArticleLikeListModal = () => {
  const likeModal = new Modal(document.getElementById(LIKE_MODAL_ID) as HTMLElement)
  likeModal.show()
}

const showDeleteCommentModal = (comment: CommentType) => {
  selectedComment.value = comment
  changeModalElevation(ARTICLE_MODAL_ID, 'backdrop')
  deleteCommentConfirmModal.value.show()
}

const showUpdateStatusCommentModal = (comment: CommentType) => {
  selectedComment.value = comment
  console.log(selectedComment.value.published)
  changeModalElevation(ARTICLE_MODAL_ID, 'backdrop')
  modalConfirmStatusComment.value.show()
}

const showCommentUserDetailInformation = async (comment: CommentType) => {
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_PROFILE_DETAIL, { id: route.params.id, userID: comment.management_no, userType: comment.user_type, isAdmin: true })
  changeModalElevation(ARTICLE_MODAL_ID, 'backdrop')
  if (comment.user_type === 'alumni') {
    commentAlumniInfoModal.value?.show()
  } else {
    commentUserInfoModal.value?.show()
  }
}

const updateCommentPublishedState = async () => {
  const requestPayload = {
    post_id: selectedArticle.value?.id ?? 0,
    comment_id: selectedComment.value?.id ?? 0,
    published: !selectedComment.value.published,
  }
  const result = await store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.UPDATE_COMMENT, requestPayload)
  resultUpdateStatusComment.success = result.success
  resultUpdateStatusComment.commentPublished = requestPayload.published
  componentModalConfirmComment.value.loadingButton = false
  modalConfirmStatusComment.value.hide()
  changeModalElevation(ARTICLE_MODAL_ID, 'backdrop')
  modalUpdateStatusCommentResult.value.show()
}

const onDeleteCommentConfirmClick = () => {
  let params = {
    create_by_admin: true,
    comment_published_flg: selectedComment.value.published,
  }
  postServices
    .deleteComment(selectedArticle.value.id, selectedComment.value.id, params)
    .then((result) => {
      if (result.status === 200 && result.data.success) {
        deleteResult.value = { success: true }
        showCommentDeleteCompleteModal()
      }
    })
    .catch((error) => {
      console.log(error)
    })
    .finally(() => {
      if (!articleDetailModalController.value?.reloadCommentList()) {
        getArticleDetail()
      }
    })
}

const getArticleDetail = async () => {
  await store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.GET_ARTICLE_DETAIL, {
    screen: 'CK10',
    community_id: route.params.id,
    postId: selectedArticle.value?.id ?? 0,
    params: {
      target_content_id: route.query?.target_content_id,
    },
  })
}

const getUserMention = async () => {
  await store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.GET_USER_MENTION_LIST, { id: selectedArticle.value?.id ?? 0, create_by_admin: true })
}

const getListUser = async () => {
  await store.dispatch(ACCOUNT_STORE.ACTIONS.SET_USER_WITH_DELETED, route?.params?.id)
}

const showArticleContentModal = () => {
  const articleModal = new Modal(document.getElementById(ARTICLE_MODAL_ID) as HTMLElement)
  articleModal.show()
}

const showCommentDeleteCompleteModal = () => {
  changeModalElevation(ARTICLE_MODAL_ID, 'backdrop')
  deleteCommentSuccessModal.value.show()
}

const fetchCommunitySiteData = async () => {
  let query = pick(route.query, ...Object.values(URL_QUERY), 'page')
  const hasSearchQuery = allowedSortFields.find((field) => !!query[field])
  if (!hasSearchQuery) {
    query[URL_QUERY.CREATE_AT] = 'desc'
  }
  if (
    query[ARTICLE_PUBLISH_STATUS_FIELD_NAME] === ARTICLE_SEARCH_PUBLISH_STATUS_PUBLIC_VALUE ||
    query[ARTICLE_PUBLISH_STATUS_FIELD_NAME] === ARTICLE_SEARCH_PUBLISH_STATUS_PRIVATE_VALUE
  ) {
    query = omit(query, 'published_sort')
  }
  isLoading.value = true
  await store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.GET_ARTICLE_LIST, { id: route.params.id, query: { ...query, page_of_number: calculatePageSize() } })
  isLoading.value = false
}

const calculatePageSize = () => {
  const pageSize = route.query[URL_QUERY.PAGE_SIZE]?.toString() ?? ''
  if (!pageSize || isNaN(pageSize)) {
    return Number.parseInt(tablePageSizeOptions[0].value, 10)
  }
  return Number.parseInt(tablePageSizeOptions.map(({ value }) => value).includes(pageSize) ? pageSize : tablePageSizeOptions[0].value, 10)
}

const overlayModal: HTMLElement = (idModal: string) => {
  const element = document.getElementById(idModal)
  element.addEventListener('hide.bs.modal', () => {
    changeModalElevation(ARTICLE_MODAL_ID, 'higher')
  })
  return element
}

const configModalVisibleState = () => {
  deleteCommentConfirmModal.value = new Modal(overlayModal(DELETE_COMMENT_MODAL_ID))
  deleteCommentSuccessModal.value = new Modal(overlayModal(DELETE_COMMENT_SUCCESS_MODAL_ID))
  commentUserInfoModal.value = new Modal(overlayModal(COMMENT_USER_MODAL_ID))
  commentAlumniInfoModal.value = new Modal(overlayModal(COMMENT_USER_ALUMNI_MODAL_ID))
  modalConfirmStatusComment.value = new Modal(overlayModal(CONFIRM_UPDATE_STATUS_COMMENT_MODAL_ID))
  modalUpdateStatusCommentResult.value = new Modal(overlayModal(RESULT_UPDATE_STATUS_COMMENT_MODAL_ID))

  document.getElementById(ARTICLE_MODAL_ID).addEventListener('hide.bs.modal', () => {
    store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.CLEAR_SELECTED_DATA)
    store.dispatch(COMMUNITY_SITE_ADMIN_STORE.ACTIONS.GET_ARTICLE_DETAIL, {
      screen: 'CK10',
      community_id: route.params.id,
      postId: selectedArticle.value?.id ?? 0,
      destination: 'list',
    })
    articleDetailModalController.value?.resetCommentInput()
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Breadcrumb, {
      breadcrumb: _unref(breadcrumb)(_unref(route).params?.id.toString()),
      class: "mx-0"
    }, null, 8, ["breadcrumb"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(translate)('CK10ArticleList')), 1),
      _createVNode(CommunitySiteArticleSearch),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Button, {
          title: _unref(translate)('CK10WriteAnArticle'),
          type: "secondary",
          onClick: handleWriteArticleButtonClick
        }, null, 8, ["title"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(TotalRecords, {
        totalRecords: _unref(totalRecords),
        "is-checked": false
      }, null, 8, ["totalRecords"]),
      _createVNode(TablePagination, {
        class: "d-lg-flex",
        "page-size": _unref(getPageSize),
        "number-of-pages": _unref(totalPages)
      }, null, 8, ["page-size", "number-of-pages"]),
      _createVNode(Table, {
        columns: _unref(displayColumns)(sortField.value),
        sortCells: _unref(allowedSortFields),
        class: "table-responsive community-site-table"
      }, {
        default: _withCtx(() => [
          (_unref(checkNoData))
            ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(checkSearchData) ? _unref(translate)('CK10NoSearchData') : _unref(translate)('OE65noData')), 1)
              ]))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data), (item, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "align-middle text-center stripe-table",
              key: index
            }, [
              _createVNode(TableRowData, {
                article: item,
                "on-cell-click": handleArticleAction,
                "time-not-seperate": true
              }, null, 8, ["article"])
            ]))
          }), 128))
        ]),
        _: 1
      }, 8, ["columns", "sortCells"]),
      _createVNode(TablePagination, {
        class: "d-lg-flex mt-3",
        "page-size": _unref(getPageSize),
        "number-of-pages": _unref(totalPages)
      }, null, 8, ["page-size", "number-of-pages"])
    ]),
    _createVNode(DeleteConfirmModal, {
      article: selectedArticle.value,
      "handle-delete": deleteArticle,
      "on-submit": isLoading.value
    }, null, 8, ["article", "on-submit"]),
    _createVNode(DeleteCompleteModal, {
      "content-message": deleteResult.value.success ? undefined : _unref(translate)('CN10failedDel')
    }, null, 8, ["content-message"]),
    _createVNode(LikeModal, { modalId: _unref(LIKE_MODAL_ID) }, null, 8, ["modalId"]),
    _createVNode(ArticleModal, {
      ref: (_value, _refs) => {
        _refs['articleDetailModalController'] = _value
        articleDetailModalController.value = _value
      },
      modalId: _unref(ARTICLE_MODAL_ID),
      onShowDeleteCommentModal: showDeleteCommentModal,
      onUpdateCommentPublishedState: showUpdateStatusCommentModal,
      onShowCommentUserDetailInformation: showCommentUserDetailInformation
    }, null, 8, ["modalId"]),
    _createVNode(DeleteCommentModal, { handleDeleteClick: onDeleteCommentConfirmClick }),
    _createVNode(DeleteCommentCompleteModal, { "is-delete": deleteResult.value }, null, 8, ["is-delete"]),
    _createVNode(PortfolioAlumni),
    _createVNode(PortfolioUser),
    _createVNode(Loading, { loading: isLoading.value }, null, 8, ["loading"]),
    _createVNode(ModalConfirmStatusComment, {
      onSubmitConfirm: updateCommentPublishedState,
      onCommunitySitePost: true,
      commentPublished: selectedComment.value?.published,
      ref: (_value, _refs) => {
        _refs['componentModalConfirmComment'] = _value
        componentModalConfirmComment.value = _value
      }
    }, null, 8, ["commentPublished"]),
    _createVNode(ModalUpdateStatusCommentResult, {
      "result-success": _unref(resultUpdateStatusComment).success,
      "comment-published": _unref(resultUpdateStatusComment).commentPublished
    }, null, 8, ["result-success", "comment-published"])
  ], 64))
}
}

})